import { render, staticRenderFns } from "./ContestWinnersModal.vue?vue&type=template&id=6cf96ece&"
import script from "./ContestWinnersModal.vue?vue&type=script&lang=js&"
export * from "./ContestWinnersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports